import { ADOBE_SIMILAR_ITEMS_PAGE_IMPRESSION_KEY } from "../../../../../../services/analytics/constants";

export const receiveSimilarItems = (state, { payload: similarItems }) => ({
  ...state,
  trackPage: {
    ...state.trackPage,
    similarItemsCount: similarItems.length,
    similarItemsIds: similarItems.map(({ id }) => id).join(","),
    events: [ADOBE_SIMILAR_ITEMS_PAGE_IMPRESSION_KEY]
  }
});
